import React, { Component } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
export default class ModaleConfirmationDelete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
    };
  }
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }

  render() {
    return (
      <StyleRoot>
        <div
          className="modal modal-skin show actif"
          id="modalDelete"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => this.props.onCloseModaleConfirmationDelete(e)}
                >
                  <Close className="img-fluid" alt="" />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title">Annuler un événement</h5>
                  </section>
                  <section>
                    <h5>
                      Vous souhaitez supprimer définitivement l'événement?
                    </h5>
                  </section>
                  <p className="bottom-space"></p>
                  <section>
                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn-gradient btn-confirm"
                        onClick={(e) => this.props.handleDeleteEvent(e)}
                      >
                        <img
                          src="img/icon-check-white.svg"
                          class="img-fluid"
                          alt=""
                        />{" "}
                        Confirmer
                      </button>
                    </div>
                  </section>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
